import { fetchResource } from "../helpers/network";
import { receiveAccounts } from "./accounts";
import { receiveUsers } from "./users";
import { setErrorNotification } from "./notifications";
import {ACCOUNTS_LIMIT} from "../helpers/accounts";
export const GET_SUGGESTIONS = "GET_SUGGESTIONS";
export const CLEAR_SUGGESTIONS = "CLEAR_SUGGESTIONS";

export const SET_SEARCH_INPUT_VALUE = "SET_SEARCH_INPUT_VALUE";

export const setInputValue = value => ({
  type: SET_SEARCH_INPUT_VALUE,
  value
});

export const getSuggestionsCreator = suggestions => ({
  type: GET_SUGGESTIONS,
  suggestions
});

export const clearSuggestions = () => ({
  type: CLEAR_SUGGESTIONS
});

/* 
The only reason this is a THUNK is that we need to access entities state from search
*/

export const getSuggestionsFromStore = params => {
  return (dispatch, getState) => {
    const { value } = params;
    const val = value.trimLeft().toLowerCase();
    const len = val.length;
    const state = getState();
    const { accounts, users } = state.entities;
    const suggestions = [];

    if (len > 0) {
      const accountSuggestions = Object.keys(accounts)
        .filter(id => accounts[id].name.toLowerCase().indexOf(val) > -1)
        .map(id => ({
          text: accounts[id].name,
          id: id,
          type: "account"
        }));
      accountSuggestions.unshift({ type: "paymentMethod" });
      accountSuggestions.unshift({ type: "accountStatus" });

      suggestions.push({
        title: "Accounts",
        suggestions: accountSuggestions
      });

      const peopleSuggestions = Object.keys(users)
        .filter(id => users[id].email.toLowerCase().indexOf(val) > -1)
        .map(id => ({
          text: users[id].email,
          id: id,
          type: "user",
          secondary:
            accounts[users[id].account] && accounts[users[id].account].name
        }));

      suggestions.push({ title: "People", suggestions: peopleSuggestions });
    }
    return dispatch(getSuggestionsCreator(suggestions));
  };
};

/*
I have to admit I'm still a little confused by THUNK 
and am only getting things working by trial and error.

So - what is going on below?: 

We want to populate the autosuggest window with data 
that may not yet be available in the store. So:

1. We attempt to get the accounts from the server by 
dispatching fetchResource(). We don't want to set a 
loading spinner - hence null for second arg.

If success, we first dispatch receiveAccounts() which puts 
the accounts in the store.
Then we dispatch another fetchResource to get the users. 
Same thing - no loading spinner. 
If fetching users is successful we dispatch receiveUsers()
which puts them in the store too, and then getSuggestionsFromStore()
which takes thosew users that match the quiery and puts 
them in the sufggestions list.
*/
export const getSuggestionsFromApi = params => {
  return dispatch => {
    dispatch(
      fetchResource(
        { path: "/accounts", limit: ACCOUNTS_LIMIT },
        null,
        json => {
          const accsResult = dispatch(receiveAccounts(json));
          dispatch(
            fetchResource(
              { path: "/users", limit: ACCOUNTS_LIMIT },
              null,
              json => {
                const usersResult = dispatch(receiveUsers(json));
                dispatch(getSuggestionsFromStore(params));
                return usersResult;
              },
              setErrorNotification
            )
          );
          return accsResult;
        },
        setErrorNotification
      )
    );
  };
};

/*
TODO - check if the following nested dispatch calls should return their result
*/
export const getSuggestions = params => {
  return (dispatch, getState) => {
    const { value } = params;
    if (value.trimLeft().toLowerCase().length > 0) {
      dispatch(getSuggestionsFromStore(params));
      dispatch(getSuggestionsFromApi(params));
    } else {
      dispatch(clearSuggestions());
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/search.js